import { Clip } from '@features/Clip';
import { FacetFieldConfig } from '@features/facetingEngine';

export const SUPPORTED_CFD_KEYS = [
    'bitRate',
    'codec',
    'commercialOffer',
    'container',
    'created',
    'customer',
    'lto',
    'preservationCategory',
    'mediaObjectType',
    'fps',
    'resolution',
    'aspectRatio',
    'size',
    'status',
    'updated',
] as const;

export type SupportedCFDKeys = (typeof SUPPORTED_CFD_KEYS)[number];

export const CLIP_FACET_CONFIG: FacetFieldConfig<Clip>[] = [
    {
        key: 'preservationCategory',
        type: 'boolean',
        presets: ['Audio', 'DSM', 'Pivot vidéo', 'Sous-titres', 'Rushes-Scans'],
    },
    {
        key: 'commercialOffer',
        type: 'boolean',
        presets: ['Digital Storage', 'E-Servicing', 'E-Transit', 'EP-Chaud'],
    },
    {
        key: 'mediaObjectType',
        type: 'boolean',
        presets: ['AUDIO', 'DOCUMENT', 'IMAGE', 'PACKAGE', 'VIDEO'],
    },
    {
        key: 'codec',
        type: 'boolean',
        presets: [
            {
                key: '_high_quality',
                values: ['_prores', '_avc', '_dnxhd', 'mxf'],
            },
            { key: '_subtitles', values: ['_subtitles'] },
            '_prores',
            '_avc',
            '_dnxhd',
        ],
    },
    {
        key: 'container',
        type: 'boolean',
        presets: ['_dcp', '_dsm', '_base_media', '_quicktime'],
    },
    {
        key: 'fps',
        type: 'boolean',
        presets: [
            // {
            //     key: '_broadcast_drop-Frame',
            //     values: ['23.98', '29.97', '59.94'],
            // },
            '24',
            '25',
            '23.98',
        ],
    },
    {
        key: 'resolution',
        type: 'boolean',
        presets: [{ key: '_4k_uhd', values: ['_4k', '_uhd'] }, '_fhd', '_sd'],
    },
    {
        key: 'created',
        type: 'date',
        presets: [
            {
                key: '_past_24h',
                value: { min: 'NOW-1DAY', max: 'NOW' },
            },
            {
                key: '_past_week',
                value: { min: 'NOW-7DAYS', max: 'NOW' },
            },
            {
                key: '_past_month',
                value: { min: 'NOW-1MONTH', max: 'NOW' },
            },
            {
                key: '_this_year',
                value: { min: 'NOW/YEAR', max: 'NOW' },
            },
        ],
    },
    {
        key: 'aspectRatio',
        type: 'boolean',
    },
];

export const CLIP_FACET_REGISTRY: FacetFieldConfig<Clip>[] = [
    ...CLIP_FACET_CONFIG,
    {
        key: 'bitRate',
        type: 'range',
        unit: 'bps',
        rangeLimits: { min: 0, max: 100_000, step: 100 },
        presets: [
            {
                key: 'Small (< 100MB)',
                value: { max: 0.1 },
            },
            {
                key: 'Medium (100MB - 1GB)',
                value: { min: 0.1, max: 1.024 },
            },
            {
                key: 'Large (> 1GB)',
                value: { min: 1.024 },
            },
        ],
    },
    {
        key: 'size',
        type: 'range',
        unit: 'Gb',
        rangeLimits: { min: 0, max: 1_000, step: 0.1 },
        presets: [
            {
                key: 'Small (< 100MB)',
                value: { max: 0.1 },
            },
            {
                key: 'Medium (100MB - 1GB)',
                value: { min: 0.1, max: 1.024 },
            },
            {
                key: 'Large (> 1GB)',
                value: { min: 1.024 },
            },
        ],
    },
];
